import { BasePage } from "../../common/BasePage";
import ClusteringChart from "./ChartComponent";

export const TestPage = () => {
  return (
    <BasePage>
      <ClusteringChart></ClusteringChart>
    </BasePage>
  );
};
